import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import i18n from 'micro-i18n';
import Modal, { ModalDirection } from 'components/modal/Modal';
import { handleNoShiftKeyCodeTriggers, handleShiftKeyCodeTriggers, isNullOrUndefOrEmpty, onFocusRef } from 'utils';
import { KeyboardEventKeyCode } from 'consts';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/compliance/ComplianceModal.scss';

const ComplianceModal = ({
  onComplianceAgree,
  complianceUrl,
  showModal,
  theme,
  closeFocusRef,
  id,
  focusable = false
}) => {
  if (!onComplianceAgree && isNullOrUndefOrEmpty(complianceUrl)) {
    return null;
  }
  const modalFocusRef = useRef(null);
  const closeButtonBottomRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // useEffect for showModal
  useEffect(() => {
    if (showModal === false) {
      setIsSubmitting(false);
    }
  }, [showModal]);

  const onTabKey = (event, focusRef, checkShift = false) => {
    const shiftKeyHandler = checkShift ? handleShiftKeyCodeTriggers : handleNoShiftKeyCodeTriggers;

    return shiftKeyHandler(event, [KeyboardEventKeyCode.Tab], () => onFocusRef(focusRef));
  };

  const onChoose = (isAgree) => {
    setIsSubmitting(true);
    onComplianceAgree(isAgree);
  };

  return (
    <Modal id={id}
           className="csw-compliance-modal"
           showModal={showModal}
           direction={ModalDirection.Bottom}
           theme={theme}
           openFocusRef={modalFocusRef}
           closeFocusRef={closeFocusRef}
           focusable={focusable}
           ariaLabeledById={`${id}-heading`}
           escapable={false}>
      <div className="csw-compliance-modal-message">

        <div className="h3 outline"
             role="heading"
             aria-level="1"
             ref={modalFocusRef}
             tabIndex="0"
             id={`${id}-heading`}
             onKeyDown={(e) =>
               onTabKey(e, closeButtonBottomRef, true)}>
          {i18n.t('COMPLIANCE_MODAL_TITLE')}
        </div>
        <p>
          <span>
            {i18n.t('COMPLIANCE_MODAL_MESSAGE')}
          </span> <a className="csw-compliance-link outline"
                     href={complianceUrl} target="_blank"
                     rel="noopener noreferrer">{i18n.t('PRIVACY_POLICY_CIVICSCIENCE')}</a>
        </p>

      </div>

      {showModal &&
        <div className="csw-btns csw-stretch">
          <button type="button"
                  role="button"
                  className="csw-btn outline"
                  tabIndex="0"
                  disabled={isSubmitting}
                  onClick={() => onChoose(true)}>
            {i18n.t('BUTTON_I_AGREE')}
          </button>
          <button type="button"
                  ref={closeButtonBottomRef}
                  role="button"
                  className="csw-btn csw-btn-first outline"
                  tabIndex="0"
                  disabled={isSubmitting}
                  onKeyDown={(e) => onTabKey(e, modalFocusRef)}
                  onClick={() => onChoose(false)}>
            {i18n.t('BUTTON_I_DISAGREE')}
          </button>
        </div>}
    </Modal>
  );
};

ComplianceModal.propTypes /* remove-proptypes */ = {
  onComplianceAgree: PropTypes.func.isRequired,
  complianceUrl: PropTypes.string.isRequired,
  showModal: PropTypes.bool,
  theme: PropTypes.string,
  closeFocusRef: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  focusable: PropTypes.bool
};

export default ComplianceModal;
